import type { CourseHole } from '@/lib/db/types';
import type { DotsHoleState } from '@/lib/games/engine/types';

export interface DotDef {
  id: string;
  label: string;
  val: number;
  auto?: boolean;
  par3?: boolean;
}

export const DEFAULT_DOTS: DotDef[] = [
  { id: 'eagle', label: 'Eagle', val: 4, auto: true },
  { id: 'birdie', label: 'Birdie', val: 2, auto: true },
  { id: 'greenie', label: 'Greenie', val: 1, par3: true },
  { id: 'sandy', label: 'Sandy', val: 1 },
  { id: 'updown', label: 'Up & Down', val: 1 },
  { id: 'threeputt', label: '3-Putt', val: -1 },
];

export function dotsHolePoints(
  holeIx: number,
  playerKey: string,
  gross: number,
  hole: CourseHole,
  dots: DotDef[],
  holeState?: DotsHoleState,
): number {
  const manual = holeState?.manual?.[playerKey] ?? [];
  let s = 0;
  dots.forEach((d) => {
    if (d.auto) {
      if (d.id === 'eagle' && gross <= hole.par - 2) s += d.val;
      if (d.id === 'birdie' && gross === hole.par - 1) s += d.val;
    } else if (!d.par3 || hole.par === 3) {
      if (manual.includes(d.id)) s += d.val;
    }
  });
  return s;
}

export function computeDotsTotals(
  playerKeys: string[],
  scores: Record<string, (number | null)[]>,
  holes: CourseHole[],
  dots: DotDef[],
  holeStateByHole: Record<number, DotsHoleState> = {},
): Record<string, number> {
  const totals: Record<string, number> = {};
  playerKeys.forEach((k) => { totals[k] = 0; });
  holes.forEach((h, hi) => {
    const hs = holeStateByHole[hi + 1] ?? holeStateByHole[hi];
    playerKeys.forEach((key) => {
      const g = scores[key]?.[hi];
      if (g == null) return;
      totals[key] += dotsHolePoints(hi, key, g, h, dots, hs);
    });
  });
  return totals;
}
